import { render, staticRenderFns } from "./CreateOrSelectPatient.vue?vue&type=template&id=d97211aa"
import script from "./CreateOrSelectPatient.vue?vue&type=script&lang=js"
export * from "./CreateOrSelectPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports